// React Hooks:
import React, { useState, useEffect } from "react";
// React-Router-Dom:
import { useNavigate } from "react-router-dom";
// MUI Components:
import {
  Container,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIcon,
  useTheme,
} from "@mui/material";
// MUI Styles:
import { makeStyles } from "@mui/styles";
// Icones:
import { ReactComponent as HomeIcon } from "../../../assets/icons/home-icon.svg";
import { ReactComponent as TableIcon } from "../../../assets/icons/table-icon.svg";
import { ReactComponent as KeyIcon } from "../../../assets/icons/key2-icon.svg";
import { ReactComponent as UserManagementIcon } from "../../../assets/icons/user-management.svg";
import { getCookie } from "../../../configs/cookie-helper/cookieHelper";

const useStyles = makeStyles((theme) => ({
  sidebarContainer: {
    width: "100%",
    height: "100%",
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.text.primary,
    overflow: "hidden",
  },
  listItem: {
    "& span": {
      fontSize: "1rem",
    },
  },
  active: {
    backgroundColor: `${theme.palette.secondary.light} !important`,
    "&:hover": {
      backgroundColor: `${theme.palette.secondary.dark} !important`,
    },
  },
}));

const menuItemUser = [
  {
    name: "Home",
    path: "/",
    icon: HomeIcon,
  },
  {
    name: "Reports",
    path: "/reports",
    icon: TableIcon,
  },
  {
    name: "Password",
    path: "/edit-password",
    icon: KeyIcon,
  },
];

const menuItemAdmin = [
  {
    name: "Home",
    path: "/",
    icon: HomeIcon,
  },
  {
    name: "Reports",
    path: "/reports",
    icon: TableIcon,
  },
  {
    name: "User Management",
    path: "/user-management",
    icon: UserManagementIcon,
  },
];

const Sidebar = () => {
  const classes = useStyles();
  const theme = useTheme();

  const rule = getCookie("rule");

  const menuItem = rule === "1" ? menuItemAdmin : menuItemUser;

  const navigate = useNavigate();

  const [active, setActive] = useState(0);

  const location = window.location.pathname;
  useEffect(() => {
    switch (location.split("/")[1]) {
      case "":
        setActive(0);
        break;
      case "reports":
        setActive(1);
        break;
      case "edit-password":
        setActive(2);
        break;
      case "user-management":
        setActive(2);
        break;
      case "create-user":
        setActive(2);
        break;
      default:
        setActive(-1);
        break;
    }
  }, [location]);

  const activeHandler = (id: number) => {
    menuItem.map((item, index) => id === index && setActive(index));
  };

  return (
    <Container
      sx={{
        p: { xs: 0 },
        m: { xs: 0 },
      }}
      className={classes.sidebarContainer}
    >
      <List
        sx={{
          p: "16px",
          [theme.breakpoints.down("md")]: {
            p: "16px 12px",
          },
          [theme.breakpoints.down(700)]: {
            p: "16px 8px",
          },
        }}
      >
        {menuItem.map((item, index) => (
          <ListItem
            key={index}
            disablePadding
            sx={{
              display: "block",
            }}
            className={classes.listItem}
          >
            <ListItemButton
              sx={{
                minHeight: "50px",
                borderRadius: "5px",
                justifyContent: "flex-start",
                p: "12px 16px",
                m: "0px 0px 8px 0px ",
                "&:hover": {
                  backgroundColor: theme.palette.secondary.dark,
                },
                [theme.breakpoints.down("lg")]: {
                  p: "6px 10px",
                },
                [theme.breakpoints.down("md")]: {
                  minHeight: "40px",
                },
              }}
              onClick={(event) => {
                event.stopPropagation();

                if (`/${location.split("/")[1]}` !== item.path) {
                  activeHandler(index);
                  navigate(item.path);
                }
              }}
              className={active === index ? classes.active : ""}
            >
              <ListItemIcon
                sx={{
                  minWidth: 0,
                  mr: "8px",
                  justifyContent: "center",
                  [theme.breakpoints.down("md")]: {
                    mr: "6px",
                  },
                }}
              >
                <SvgIcon
                  component={item.icon}
                  inheritViewBox
                  sx={{
                    height: "18px",
                    color: theme.palette.text.primary,
                  }}
                />
              </ListItemIcon>
              <ListItemText
                primary={item.name}
                sx={{
                  m: 0,
                  "& span": {
                    lineHeight: "normal",
                    pt: "2px",
                  },
                }}
              />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Container>
  );
};

export default Sidebar;
